import { Theme } from '@mui/material/styles';

export const getStyles = (theme: Theme) => ({
  container: {
    padding: theme.spacing(2),
  },
  table: {
    minWidth: 650,
  },
  tableCell: {
    fontSize: '18px'
  }
});
